// Deduplicate concurrent init calls (e.g. React Strict Mode double effect) — same promise per key.

const inflight = new Map();

function makeKey({ userId, organizationId, sessionId, themeName }) {
  const t = themeName || 'health-sprint';
  return `${userId}|${organizationId}|${sessionId}|${t}`;
}

export async function initQuestions({
  userId,
  email,
  fullName,
  themeName,
  organizationId,
  sessionId,
  token,
  user_type,
  reportid
}) {
  const key = makeKey({ userId, organizationId, sessionId, themeName });
  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const p = (async () => {
    const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/setUserQuestions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        userId,
        email,
        fullName,
        themeName,
        organizationId,
        sessionId,
        user_type,
        reportid,
      })
    });

    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to initialize questions');
    }
    return resp.json();
  })();

  inflight.set(key, p);
  try {
    return await p;
  } finally {
    inflight.delete(key);
  }
}
